import {
  DollarSign, Users, BarChart3, CreditCard, ShoppingCart, Package,
  Activity, Zap, Target, Award, Calendar, Clock, FileText, Mail,
  Phone, MapPin, Home, Settings, TrendingUp, List, MinusSquare,
  Circle, Search, CheckSquare, Grid, type LucideIcon
} from 'lucide-react';

// Mapeamento de emojis para ícones Lucide
export const ICON_MAP: Record<string, LucideIcon> = {
  '💰': DollarSign,
  '👥': Users,
  '📊': BarChart3,
  '💳': CreditCard,
  '🛒': ShoppingCart,
  '📦': Package,
  '💪': Activity,
  '⚡': Zap,
  '🎯': Target,
  '🏆': Award,
  '📅': Calendar,
  '⏰': Clock,
  '📄': FileText,
  '📧': Mail,
  '📞': Phone,
  '📍': MapPin,
  '🏠': Home,
  '⚙️': Settings,
  '📈': TrendingUp,
  '📋': List,
  '📝': FileText,
  '➖': MinusSquare,
  '🔘': Circle,
  '🔍': Search,
  '✅': CheckSquare,
  '🎨': Grid,
};

// Componente helper para renderizar ícones
interface IconRendererProps {
  icon?: string;
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function IconRenderer({ icon, className = "w-5 h-5", size, strokeWidth = 2 }: IconRendererProps) {
  if (!icon) return null;

  const IconComponent = ICON_MAP[icon];
  
  if (IconComponent) {
    return <IconComponent className={className} size={size} strokeWidth={strokeWidth} />;
  }

  // Fallback para emojis não mapeados
  return <span className={className}>{icon}</span>;
}
